import { ref, computed, watch, getCurrentInstance } from 'vue'
import store from '@/store'
import { useToast } from '@/composables/common/useToast'

export function useAbonosSvg({ svgAlias, extraParams = {} }) {
    
    const svg = ref(null)
    const loading = ref(false)
    const error = ref(null)

    const instance = getCurrentInstance()
    const config = instance?.proxy?.config ?? store.getters.getConfig

    const listaAbonadosId = computed(() => store.getters.getListaAbonados?.id)

    function getSvgCode() {
        loading.value = true
        const lista = store.getters.getListaAbonados
        const recinto = store.getters.getRecinto
        if (!lista?.id) {
            loading.value = false
            return
        }

        store.dispatch(config.getVuexAlias(svgAlias), {
            filters: {},
            recinto_id: recinto.id,
            lista_id: lista.id,
            ...extraParams
        }).then(res => {
            svg.value = res.data.svg
        }).catch(err => {
            console.error('SVG load error:', err)
            error.value = err
            useToast().error('Error al cargar el plano de la sección')
        }).finally(() => {
            loading.value = false
        })
    }

    watch(listaAbonadosId, newVal => {
        if (newVal && !svg.value) getSvgCode()
    }, { immediate: true })

    return { svg, loading, error, getSvgCode }
}
